import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface MobileDrawerContextValue {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  toggleDrawer: () => void;
}

const MobileDrawerContext = createContext<MobileDrawerContextValue | null>(null);

export function MobileDrawerProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = useCallback(() => setIsOpen(true), []);
  const closeDrawer = useCallback(() => setIsOpen(false), []);
  const toggleDrawer = useCallback(() => setIsOpen((prev) => !prev), []);

  return (
    <MobileDrawerContext.Provider value={{ isOpen, openDrawer, closeDrawer, toggleDrawer }}>
      {children}
    </MobileDrawerContext.Provider>
  );
}

const noopDrawer: MobileDrawerContextValue = {
  isOpen: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  openDrawer: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  closeDrawer: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleDrawer: () => {},
};

export function useMobileDrawer(): MobileDrawerContextValue {
  // Return no-op fallback instead of throwing — MobileDrawer and BottomNavItem are used in
  // Navbar which could theoretically render outside a MobileDrawerProvider (e.g. error pages)
  return useContext(MobileDrawerContext) ?? noopDrawer;
}
